import React from 'react';

export const GoogleCalendarSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2230_18795)">
			<path
				d="M27.8948 12.1052L20.7896 11.3158L12.1054 12.1052L11.3158 20L12.1052 27.8948L20 28.8817L27.8948 27.8948L28.6843 19.8028L27.8948 12.1052Z"
				fill="white"
			/>
			<path
				d="M15.3441 24.3539C14.754 23.9552 14.3454 23.373 14.1224 22.6032L15.4922 22.0388C15.6165 22.5125 15.8336 22.8795 16.1435 23.1401C16.4514 23.4006 16.8264 23.5289 17.2646 23.5289C17.7126 23.5289 18.0975 23.3927 18.4191 23.1203C18.7407 22.8479 18.9027 22.5005 18.9027 22.0802C18.9027 21.65 18.7329 21.2985 18.3935 21.0263C18.054 20.754 17.6277 20.6177 17.1185 20.6177H16.3271V19.2618H17.0375C17.4756 19.2618 17.8448 19.1435 18.1448 18.9066C18.4448 18.6698 18.5948 18.3461 18.5948 17.9336C18.5948 17.5665 18.4605 17.2743 18.1922 17.0553C17.9238 16.8363 17.5842 16.7258 17.1717 16.7258C16.7691 16.7258 16.4493 16.8324 16.2125 17.0475C15.9756 17.2626 15.8039 17.5271 15.6954 17.8389L14.3396 17.2745C14.5191 16.7652 14.8488 16.3152 15.3323 15.9264C15.8159 15.5376 16.4336 15.3422 17.1836 15.3422C17.7381 15.3422 18.2375 15.4488 18.6797 15.6639C19.1217 15.879 19.4691 16.1771 19.7198 16.556C19.9704 16.9368 20.0948 17.3633 20.0948 17.8368C20.0948 18.3204 19.9784 18.7289 19.7454 19.0644C19.5125 19.4 19.2263 19.6565 18.8868 19.8362V19.917C19.3349 20.1045 19.7 20.3907 19.9881 20.7756C20.2743 21.1605 20.4183 21.6204 20.4183 22.1573C20.4183 22.6941 20.2821 23.1737 20.0097 23.5941C19.7373 24.0146 19.3604 24.3461 18.8828 24.5868C18.4032 24.8276 17.8644 24.95 17.2664 24.95C16.5737 24.9519 15.9342 24.7526 15.3441 24.3539Z"
				fill="#1A73E8"
			/>
			<path
				d="M23.7495 17.5566L22.2534 18.6441L21.5015 17.5034L24.1995 15.5573H25.2338V24.7368H23.7495V17.5566Z"
				fill="#1A73E8"
			/>
			<path
				d="M27.8948 35L35 27.8948L31.4474 26.3159L27.8948 27.8948L26.3159 31.4474L27.8948 35Z"
				fill="#EA4335"
			/>
			<path
				d="M10.5262 31.4474L12.1051 35H27.8946V27.8948H12.1051L10.5262 31.4474Z"
				fill="#34A853"
			/>
			<path
				d="M7.36835 5C6.0599 5 5 6.0599 5 7.36835V27.8946L8.5526 29.4736L12.1052 27.8946V12.1052H27.8946L29.4736 8.5526L27.8948 5H7.36835Z"
				fill="#4285F4"
			/>
			<path
				d="M5 27.8948V32.6317C5 33.9403 6.0599 35 7.36835 35H12.1052V27.8948H5Z"
				fill="#188038"
			/>
			<path
				d="M27.8943 12.1053V27.8948H34.9995V12.1053L31.4469 10.5264L27.8943 12.1053Z"
				fill="#FBBC04"
			/>
			<path
				d="M34.9995 12.1052V7.36835C34.9995 6.05975 33.9396 5 32.6311 5H27.8943V12.1052H34.9995Z"
				fill="#1967D2"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2230_18795">
				<rect width="30" height="30" fill="white" transform="translate(5 5)" />
			</clipPath>
		</defs>
	</svg>
);
